import BaseService from './base.service';

export default class FreshchatService extends BaseService {
  initFreshchat() {
    window.fcWidget.init({
      config: {
        headerProperty: {
          hideChatButton: true,
        },
      },
      host: 'https://wchat.freshchat.com',
      token: 'bf427bae-ee43-4d22-b160-4a805bf227e9',
    });

    window.fcWidget.on('widget:closed', () => {
      this.hideBubble();
    });
  }

  isInitialized() {
    if (!window.fcWidget) return false;
    return window.fcWidget.isInitialized();
  }

  hideBubble() {
    if (!window.fcWidget) return;
    if (!this.isInitialized()) this.initFreshchat();
    window.fcWidget.hide();
  }

  openDialog() {
    if (!window.fcWidget) return;
    if (!this.isInitialized()) this.initFreshchat();
    window.fcWidget.show();
    window.fcWidget.open();
  }
}
